module.exports = __webpack_public_path__ + "static/merch11Back-af7976184259b46a6892e7d452b99f66.png";